import "./NavLogout.scss";

import { useTranslation } from "react-i18next";
import { FiLogOut } from "react-icons/fi";

import useLogout from "@/hooks/useLogout";
import { useAuthStore } from "@/stores/AuthStore";

interface NavLogoutProps {
  open?: boolean;
}

const NavLogout = ({ open = true }: NavLogoutProps) => {
  const { t } = useTranslation();
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const handleLogout = useLogout();

  if (!isAuthenticated) return null;

  return (
    <button
      className={`navLogout ${open ? "open" : "closed"}`}
      onClick={handleLogout}
    >
      <FiLogOut className="navLogoutIcon" />
      {open && <span className="navLogoutLabel">{t("auth.logout")}</span>}
    </button>
  );
};

export default NavLogout;
